import { FEATURES, SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'

export default [
  {
    path: '/comissionamento',
    name: FEATURES.BROKKR,
    redirect: '/comissionamento/geral',
    meta: {
      can_show: FEATURES.BROKKR,
      search: {
        title: 'Comissionamento',
        description: 'Comissionamento de assessores (Brokkr)',
        keywords: [
          'comissionamento',
          'brokkr',
          'repasse',
          'comissão',
          'assessores',
        ],
        icon: 'mdi-sack-percent',
        group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
      },
    },
    component: () =>
      lazyLoadView(
        import(
          '@modules/commissions/views/commissions-nav-bar/commissions-nav-bar.vue'
        )
      ),
    children: [
      {
        path: 'geral',
        name: 'brokkr.geral',
        meta: {
          can_show: FEATURES.BROKKR,
          search: {
            title: 'Comissionamento — Visão Geral',
            description: 'Visão geral do comissionamento',
            keywords: ['comissionamento', 'brokkr', 'visão geral', 'resumo'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/commissions/views/view-commissions-home/view-commissions-home.vue'
            )
          ),
      },
    ],
  },

  {
    path: '/home/kat',
    name: 'home.brokkr',
    // meta: {
    //   can_show: FEATURES.HOME,
    // },
    component: () =>
      lazyLoadView(
        import('@modules/commissions/views/view-home-links/view-home-links.vue')
      ),
  },
]
